import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const MENU = {
  invoices: { label: "Invoices", to: "/invoices", perm: "invoices" },
  service_due: { label: "Service due", to: "/service-due", perm: "service_due" },
  stickers: { label: "Stickers", to: "/sticker-designer", perm: "stickers" },
  routes: { label: "Route setup", to: "/routes", perm: "routes" },
  reminders: { label: "Unpaid reminders", to: "/reminders", perm: "reminders" },
  customers: { label: "Customers", to: "/customers", perm: "customers" },
  files: { label: "Files", to: "/files" },
  admin: { label: "Admin panel", to: "/techs", admin: true },
};

export const DEFAULT_UI = { app_name: "AccessBridge", accent: "#3b82f6", start_page: "/", menu: Object.keys(MENU).map((key) => ({ key, label: "", hidden: false })) };

const hexToHsl = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  let h = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const applyUi = (ui) => {
  const hsl = hexToHsl(ui.accent || DEFAULT_UI.accent);
  document.documentElement.style.setProperty("--primary", hsl);
  document.documentElement.style.setProperty("--ring", hsl);
  document.title = ui.app_name || DEFAULT_UI.app_name;
};

let cache = null;
export const getUi = () => cache || DEFAULT_UI;
export const setUiCache = (ui) => { cache = ui; applyUi(ui); window.dispatchEvent(new Event("ui-settings-changed")); };

export function useUi() {
  const [ui, setUi] = useState(cache || DEFAULT_UI);
  useEffect(() => {
    const sync = () => setUi(cache);
    window.addEventListener("ui-settings-changed", sync);
    if (!cache) api.get("/ui-settings").then((r) => setUiCache(r.data)).catch(() => {});
    return () => window.removeEventListener("ui-settings-changed", sync);
  }, []);
  return ui;
}
